type GeneratePropertyType = (
  bedrooms: number[],
  propertyType: string
) => string | null;

export const generatePropertyType: GeneratePropertyType = (
  bedrooms,
  propertyType
) => {
  if (bedrooms.length === 0) {
    return null;
  }

  const [bedroom] = bedrooms;
  if (bedroom > 0) {
    return `${bedroom} bedroom ${propertyType}`.toLowerCase();
  }

  return 'Studio';
};
